import { Input } from '@commenda/kakashi';
import { useFormField } from '../../hooks/useFormField';
import type { ValidationRules } from '@commenda/types';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const InputComponent = ({
  fieldId,
  label,
  description,
  placeholder,
  fieldType = 'text',
  validation,
  guidance,
  props = {},
}: {
  fieldId: string;
  label: string;
  description?: string;
  placeholder?: string;
  fieldType?: string;
  validation?: {
    rules?: ValidationRules;
    triggers?: string[];
  };
  guidance?: { text?: string };
  props?: Record<string, unknown>;
}) => {
  const { value, error, disabled, isRequired, setValue } = useFormField<string>(
    fieldId,
    {
      rules: validation?.rules,
      disabledFromProps: props.disabled as boolean,
    }
  );

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          description={description}
          guidance={guidance?.text}
          isRequired={isRequired}
        />
      )}
      <Input
        type={fieldType}
        value={value || ''}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
      />
    </div>
  );
};
